import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { INFLUENCER_BASE } from "../constants";
import InfluencerSubscriptionBilling from "../../modules/influencer-subscription/components/InfluencerSubscriptionBilling";

const SubscriptionBilling = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 lg:p-6">
      <button
        type="button"
        onClick={() => navigate(`${INFLUENCER_BASE}/dashboard/settings`)}
        className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
      >
        <FaArrowLeft />
        Back to Settings
      </button>

      <div className="mb-6">
        <h1 className="text-lg font-bold text-gray-800 mb-2">Subscription & Billing</h1>
        <p className="text-sm text-gray-600">
          Your Subscription plan. Cancelling keeps access until the end of the current billing period.
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 lg:p-6">
        <InfluencerSubscriptionBilling />
      </div>
    </div>
  );
};

export default SubscriptionBilling;
